import { biDisplayFormat } from '@euler/model/bi/format';
import {
  BiFieldRole,
  BiFieldType,
  BiResultColumn,
} from '@euler/model/bi/result';
import {
  BiFormat,
  BiLegendPosition,
  BiSeriesType,
  BiVizType,
} from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
} from '../functions/biGalleryTypes';
import { galleryReady, galleryResult, kGalleryMonths } from './biGalleryFields';

// A blend's columns as the server names them: the merge key carries no
// side, each measure is prefixed by its side and labelled by its dataset.

const month: BiResultColumn = {
  key: 'date__month',
  label: { zh: '月份', en: 'Month' },
  type: BiFieldType.Date,
  role: BiFieldRole.Dimension,
};
const orders: BiResultColumn = {
  key: 'q1__order_count',
  label: { zh: '工单数（工单）', en: 'Orders (orders)' },
  type: BiFieldType.Number,
  role: BiFieldRole.Measure,
  format: biDisplayFormat(BiFormat.Integer),
  side: 0,
};
const target: BiResultColumn = {
  key: 'q2__target_orders__sum',
  label: { zh: '目标工单数（月度工单目标）', en: 'Target orders (targets)' },
  type: BiFieldType.Number,
  role: BiFieldRole.Measure,
  format: biDisplayFormat(BiFormat.Integer),
  side: 1,
};

const actual = [468, 431, 512, 547, 583, 562, 611, 638, 597, 652];
const goals = [500, 480, 520, 540, 560, 580, 600, 620, 640, null];

const result = galleryResult(
  [month, orders, target],
  kGalleryMonths.map((value, i) => [value, actual[i], goals[i]]),
);

const lines: BiGalleryDashboardCard = {
  surface: 'dashboard',
  title: '每月开单量 vs 目标',
  viz: {
    type: BiVizType.Line,
    x: month.key,
    series: [{ key: orders.key }, { key: target.key }],
  },
  data: galleryReady(result),
};

export const kBlendCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.Blend,
  name: '组合数据集',
  description: '两个数据集按月份合并，图例按数据集区分',
  preview: lines,
  variants: [
    {
      key: 'two-datasets',
      name: '两个数据集',
      note: '工单 × 上传的月度目标；10 月目标缺失为断点',
      card: lines,
    },
    {
      key: 'side-legend',
      name: '图例右侧',
      note: 'legend.position = right',
      card: {
        ...lines,
        viz: {
          ...lines.viz,
          style: {
            legend: { show: true, position: BiLegendPosition.Right },
          },
        },
      },
    },
    {
      key: 'bar-line',
      name: '柱 + 目标线',
      note: '实际为柱，目标 as = line',
      card: {
        ...lines,
        viz: {
          type: BiVizType.Bar,
          x: month.key,
          series: [
            { key: orders.key },
            { key: target.key, as: BiSeriesType.Line },
          ],
        },
      },
    },
    {
      key: 'table',
      name: '数据表',
      note: '缺失的一侧显示为 —',
      card: {
        ...lines,
        viz: {
          type: BiVizType.Table,
          columns: [
            { key: month.key },
            { key: orders.key },
            { key: target.key },
          ],
        },
        rows: 6,
      },
    },
  ],
};
